export default __webpack_public_path__ + "static/media/detail_main_img_11.8c8eb961.png";